import React from 'react';
import { ShowSection } from 'framework/ui/layout';
import { FormShowTemplate } from 'framework/form';
import CriticalPeriodsList from './CriticalPeriodsList';
import { useShowContext } from 'framework/show';
import { EditableListFormShowTemplate } from 'framework/list';

const CriticalPeriodsWrapper = () => {
  const { data } = useShowContext();

  return (
    <FormShowTemplate
      isInitialsLoadingPosition
      getValidationSchemaFunc={() => Promise.resolve({})}
      submitFormFunc={async () => {}}
      afterSubmit={{
        message: 'Periods have been successfully updated.',
      }}
      getDataFunc={async () => {
        return { criticalPeriods: data?.criticalPeriods };
      }}
    >
      <ShowSection sx={{ '&.section-details__wrapper': { p: '0px !important' } }}>
        <EditableListFormShowTemplate listSource="criticalPeriods">
          <CriticalPeriodsList />
        </EditableListFormShowTemplate>
      </ShowSection>
    </FormShowTemplate>
  );
};

export default CriticalPeriodsWrapper;
